// src/context/AdminThemeContext.js
import { createContext, useContext, useState, useEffect } from "react";

const AdminThemeContext = createContext();

export const AdminThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const savedTheme = localStorage.getItem("admin-theme"); // Different key
    if (savedTheme) setTheme(savedTheme);
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("admin-theme", newTheme); // Different key
  };

  const changeTheme = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem("admin-theme", newTheme); // Different key
  };

  // Candy Floss Evening Mode cycle
  const candyThemes = [
    "candy-green",
    "candy-lightgreen",
    "candy-blue",
    "candy-blend",
  ];
  const nextCandyTheme = () => {
    const currentIndex = candyThemes.indexOf(theme);
    const nextIndex = (currentIndex + 1) % candyThemes.length;
    const newTheme = candyThemes[nextIndex];
    setTheme(newTheme);
    localStorage.setItem("admin-theme", newTheme); // Different key
  };

  return (
    <AdminThemeContext.Provider
      value={{ theme, toggleTheme, changeTheme, nextCandyTheme }}
    >
      <div className={`theme-${theme}`}>{children}</div>
    </AdminThemeContext.Provider>
  );
};

export const useAdminTheme = () => useContext(AdminThemeContext);
